import { useCallback, useState } from 'react';

export const useTimeoutState = <T>(initialState: T): [T, (newState: T, timeout?: number) => void] => {
    const [state, _setState] = useState<T>(initialState);
    const [currentTimeoutId, setCurrentTimeoutId] = useState<NodeJS.Timeout | undefined>();

    const setState = useCallback(
        (newState: T, timeout?: number) => {
            if (currentTimeoutId != null) {
                clearTimeout(currentTimeoutId);
            }

            const id = setTimeout(() => _setState(newState), timeout);
            setCurrentTimeoutId(id);
        },
        [currentTimeoutId, initialState],
    );
    return [state, setState];
};
